import { Component, ViewEncapsulation } from "@angular/core";
import { Invitation } from "sip.js";
import { PhoneService } from "../_services/phone.service";
import { MessageService } from "primeng/api";
import { firstValueFrom } from "rxjs";
import { VOIPService } from "../../voip/_services/voip.service";
import { Case } from "../../cases/_types/case";
import { Filter, FilterOperation } from "src/app/core/jsonapi/filter";
import { CasesService } from "../../cases/_services/cases.service";
import { FilterBuilder } from "src/app/core/jsonapi/filters-builder";

@Component({
    selector: 'app-phone-call-alert',
    templateUrl: './phone-call-alert.component.html',
    styleUrls: ['./phone-call-alert.component.scss'],
    standalone: false
})
export class PhoneCallAlertComponent {

    calls: any[] = [];
    ringingCalls: any[] = [];
    cases:Case[] = [];

    constructor(
        private phoneService:PhoneService,
        private voipService:VOIPService,
        private messageService: MessageService,
        private casesService:CasesService
    ) {
        this.phoneService.onIncomingCall.subscribe((calls:any[]) => {
            console.log(calls);
            this.calls = calls;

            //preapamos expedientes de llamdas
            this.loadCases();
        });
    }

    async loadCases(){
        //si no hay llamdas, borramos los casas
        this.cases = [];

        //extraemos los caseid de las llamadas
        let caseIds:string[] = this.calls.map(call => call.caseId);
        if(caseIds.length>0){
            //obtenemos los casos
            let filter:any = {
                id: new Filter(FilterOperation.any, 'id', '', caseIds)
            };
            let params:any = { filter: FilterBuilder.fromObject(filter).build() };
            let response = await firstValueFrom(this.casesService.all(params));
            this.cases = response.data;
        }
    }


    getCalls():any[]{
        //filtramos las llamadas que tienen caseId
        return this.calls.filter(call => call.caseId && call.caseId!='');
    }

    getCaseById(caseId:string):Case | undefined{
        return this.cases.find(c => c.id === caseId);
    }


    /*getRingingCalls():any[]{
        let ringingCalls = this.calls.filter((call:any) => {
            return call.participants.filter((p:any) => p.state === 'ringing').length > 0;
        });

        //para cada participante, obtener caller-info
        ringingCalls.forEach((call:any) => {
            call.participants.forEach(async (p:any) => {
                if(p.state === 'ringing'){
                    let callerInfo:any = await firstValueFrom(this.voipService.getCallerInfo(p.number));
                    if(callerInfo){
                        call.caseId = callerInfo.caseId;
                        call.caseNumber = callerInfo.caseNumber;
                        console.log(callerInfo);
                    }
                }
            });
        });

        return ringingCalls;
    }*/

    async accept(call:any){
        await this.phoneService.answer(call);

        //si tiene caseId, lo abrimos en otra pestaña
        if(call.caseId){
            window.open('/cases/' + call.caseId, '_blank');
        }
    }

    async reject(call:any){
        await this.phoneService.hangup(call);
    }

    async goToCase(caseId:string){
        window.open('/cases/' + caseId, '_blank');
        this.calls = [];
    }

}